var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container pb-5" }, [
    _c(
      "div",
      { staticClass: "card mt-5" },
      [
        _c("center", [
          _c("img", {
            staticClass: "febos-main-logo",
            attrs: {
              src:
                "https://archivos.febos.io/publico/logos/escritoriodigital_logo_horizontal.png"
            }
          })
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "text-center mb-5" }, [
            _c("h3", [_vm._v("Verificación de documento")]),
            _vm.approvalDetails &&
            _vm.approvalDetails.ejecucion &&
            // eslint-disable-next-line max-len
            _vm.estadosOcultarDocumento.includes(
              _vm.approvalDetails.ejecucion.aprobaciones_ejecucion_estado_id
            )
              ? _c("h3", { staticClass: "text-danger" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.approvalDetails.ejecucion
                          .aprobaciones_ejecucion_estado_id == 6
                          ? "ANULADO"
                          : _vm.approvalDetails.ejecucion
                              .aprobaciones_ejecucion_estado_id == 5
                          ? "RECHAZADO"
                          : _vm.approvalDetails.ejecucion
                              .aprobaciones_ejecucion_estado_id == 1
                          ? "DESESTIMADO"
                          : "OTRO"
                      ) +
                      " "
                  )
                ])
              : _vm._e()
          ]),
          _vm.loading
            ? _c(
                "div",
                [
                  _c("center", [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src:
                            "https://portal.febos.cl/desarrollo/assets/img/logos/FEBOS_LOADER.svg",
                          width: "30"
                        }
                      })
                    ]),
                    _c("div", [
                      _vm._v(
                        " Estamos buscando el documento, danos unos segundos "
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          !_vm.loading && !_vm.approvalDetails
            ? _c("div", [
                _c(
                  "div",
                  { staticStyle: { "font-size": "110%" } },
                  [
                    _c(
                      "center",
                      [
                        _c("b-icon", {
                          staticClass: "text-danger",
                          attrs: { icon: "x-circle" }
                        }),
                        _vm._v(
                          " No encontramos información del documento consultado "
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          !_vm.loading
            ? _c("div", [
                _c(
                  "h4",
                  { staticClass: "mb-4" },
                  [
                    _c("b-icon", { attrs: { icon: "info-circle" } }),
                    _vm._v(" Información General ")
                  ],
                  1
                ),
                _vm.dte
                  ? _c(
                      "div",
                      [
                        _c("DTE", {
                          attrs: {
                            formatNumber: _vm.formatNumber,
                            dte: _vm.dte
                          }
                        })
                      ],
                      1
                    )
                  : _vm.dnt
                  ? _c(
                      "div",
                      [
                        _c("AllTypes", {
                          attrs: {
                            formatNumber: _vm.formatNumber,
                            dnt: _vm.dnt
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("NoDnt", {
                          attrs: {
                            formatNumber: _vm.formatNumber,
                            data: _vm.approvalDetails.ejecucion
                          }
                        })
                      ],
                      1
                    )
              ])
            : _vm._e(),
          !_vm.loading
            ? _c(
                "div",
                [
                  _c("hr"),
                  _vm.approvalsMustBeShown
                    ? _c("Approvals", {
                        attrs: { approvals: _vm.approvalDetails.aprobaciones }
                      })
                    : _vm._e(),
                  _vm.approvalDetails &&
                  _vm.approvalDetails.ejecucion &&
                  // eslint-disable-next-line max-len
                  !_vm.estadosOcultarDocumento.includes(
                    _vm.approvalDetails.ejecucion
                      .aprobaciones_ejecucion_estado_id
                  ) &&
                  _vm.approvalDetails.firmas
                    ? _c("DigitalSignatures", {
                        attrs: {
                          signatures: _vm.approvalDetails.firmas,
                          url: _vm.approvalDetails.url
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }